export const MenuData = [
  {
    id: "dressing",
    url: "/products/dressings",
    text: "Dressings"
  },
  {
    id: "sauces",
    url: "/products/sauces",
    text: "Sauces"
  },
  {
    id: "kits",
    url: "/products/mealKits",
    text: "Meal Kits"
  },
  {
    id: "recipes",
    url: "/recipes",
    text: "Recipes"
  }
];

export const FooterMenuData = [
  {
    id: "contact",
    url: "#",
    text: "Contact: 1-800-847-1997"
  },
  {
    id: "privacy",
    url: "/privacy",
    text: "Privacy Policy"
  }
];



// WEBPACK FOOTER //
// ./src/json/menu.js